import React,{useEffect,useState} from 'react';
import {useParams} from 'react-router-dom';
import FaceCamera from '../components/FaceCamera';

const DELIVERY_BUILDINGS = {
  '1幢': { floors: 32, unitGroups: [
    { name: '一单元', unitNo: 1, rooms: ['01','02'] },
    { name: '二单元', unitNo: 2, rooms: ['03','04'] }
  ] },
  '2幢': { floors: 32, unitGroups: [
    { name: '一单元', unitNo: 1, rooms: ['01','02'] }
  ] },
  '3幢': { floors: 32, unitGroups: [
    { name: '一单元', unitNo: 1, rooms: ['01','02'] }
  ] },
  '5幢': { floors: 32, unitGroups: [
    { name: '一单元', unitNo: 1, rooms: ['01','02'] },
    { name: '二单元', unitNo: 2, rooms: ['03','04'] }
  ] },
  '6幢': { floors: 32, unitGroups: [
    { name: '一单元', unitNo: 1, rooms: ['01','02'] },
    { name: '二单元', unitNo: 2, rooms: ['03','04'] }
  ] },
};

export default function DeliveryRegister(){
  const {token}=useParams();

  const [mode,setMode]=useState('home');
  const [info,setInfo]=useState(null);
  const [pageError,setPageError]=useState('');

  useEffect(()=>{
    fetch(`/api/delivery/public/${encodeURIComponent(token)}`)
      .then(async r=>{
        const d=await r.json();
        if(!r.ok) throw new Error(d.message||'二维码无效');
        setInfo(d);
      })
      .catch(e=>setPageError(e.message));
  },[token]);

  if(pageError)
    return <Center>❌ {pageError}</Center>;

  if(!info)
    return <Center>正在加载...</Center>;

  if(mode==='register')
    return <RegisterForm token={token} onBack={()=>setMode('home')}/>;

  if(mode==='login')
    return (
      <DeliveryEntry
        onBack={()=>setMode('home')}
        onRegister={()=>setMode('register')}
      />
    );

  return (
    <div style={s.page}>
      <Header title="人员临时通行"/>

      <div style={s.body}>
        <div style={s.card}>

          <div style={s.brand}>大诚·瓯江印象</div>

          <div style={s.icon}>🏢</div>

          <div style={s.bigTitle}>
            临时通行
          </div>

          <div style={s.desc}>
            已审核人员请使用手机号和6位通行密码申请临时通行
          </div>

          <button
            style={s.primaryBtn}
            onClick={()=>setMode('login')}
          >
            👤 申请临时通行
          </button>

          <Warning/>

          <div style={s.safe}>
            🔒 身份资料仅用于物业人员核验及小区临时通行管理
          </div>

        </div>
      </div>
    </div>
  );
}


function DeliveryEntry({onBack,onRegister}){
  const [phone,setPhone]=useState('');
  const [passcode,setPasscode]=useState('');
  const [loggedIn,setLoggedIn]=useState(false);
  const [account,setAccount]=useState(null);

  const [units,setUnits]=useState([]);
  const [buildingNo,setBuildingNo]=useState('');
  const [unitNo,setUnitNo]=useState('');
  const [unitName,setUnitName]=useState('');
  const [roomNo,setRoomNo]=useState('');

  const [busy,setBusy]=useState(false);
  const [msg,setMsg]=useState('');
  const [result,setResult]=useState(null);

  useEffect(()=>{
    fetch('/api/delivery/entry/units')
      .then(async r=>{
        const d=await r.json();
        if(!r.ok) throw new Error(d.message||'读取楼幢信息失败');
        setUnits(Array.isArray(d.units)?d.units:[]);
      })
      .catch(e=>setMsg(e.message));
  },[]);

  const buildings=[...new Set(
    units.map(x=>String(x.building_no))
  )];

  const currentUnits=units.filter(
    x=>String(x.building_no)===String(buildingNo)
  );

  async function login(){
    setMsg('');
    setResult(null);

    const p=phone.replace(/\D/g,'');
    const code=passcode.replace(/\D/g,'');

    if(!/^1\d{10}$/.test(p))
      return setMsg('请输入正确的11位手机号码');

    if(!/^\d{6}$/.test(code))
      return setMsg('请输入6位通行密码');

    setBusy(true);

    try{
      const r=await fetch('/api/delivery/entry/login',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({
          phone:p,
          passcode:code
        })
      });

      const d=await r.json();

      if(!r.ok || !d.ok)
        throw new Error(d.message||'登录失败');

      setLoggedIn(true);
      setAccount(d);
      setMsg('');
    }catch(e){
      setMsg(e.message||'登录失败');
    }finally{
      setBusy(false);
    }
  }

  async function requestAccess(){
    setMsg('');
    setResult(null);

    if(!buildingNo)
      return setMsg('请选择送达楼幢');

    if(!unitNo)
      return setMsg('请选择送达单元');

    if(!roomNo)
      return setMsg('请选择具体房号');

    setBusy(true);

    try{
      const r=await fetch('/api/delivery/entry/access-request',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({
          phone:phone.replace(/\D/g,''),
          passcode:passcode.replace(/\D/g,''),
          building_no:Number(buildingNo),
          unit_no:Number(unitNo),
          room_no:`${buildingNo}幢${unitName}${roomNo}室`
        })
      });

      const d=await r.json();

      if(!r.ok || !d.ok)
        throw new Error(d.message||'申请临时通行失败');

      setResult(d);
      setMsg('');
    }catch(e){
      setMsg(e.message||'申请临时通行失败');
    }finally{
      setBusy(false);
    }
  }

  if(result){
    return (
      <div style={s.page}>
        <Header title="临时通行已申请" back={onBack}/>

        <div style={s.body}>
          <div style={s.card}>

            <div style={s.icon}>✅</div>

            <div style={s.bigTitle}>
              临时通行申请成功
            </div>

            <div style={s.desc}>
              请在有效时间内通行，超时后权限自动失效。
            </div>

            <div style={s.resultBox}>
              <div>
                送达位置：
                <b>{result.target_unit_name}</b>
              </div>

              <div>
                通行时长：
                <b>{result.access_minutes}分钟</b>
              </div>

              <div>
                生效时间：
                <b>{result.valid_from}</b>
              </div>

              <div>
                失效时间：
                <b>{result.valid_until}</b>
              </div>
            </div>

            <div style={s.accessTip}>
              可通行范围：小区公共入口 + 本次选择的目标单元门禁。
            </div>

            <button
              style={s.grayBtn}
              onClick={onBack}
            >
              完成
            </button>

          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={s.page}>
      <Header title="申请临时通行" back={onBack}/>

      <div style={s.body}>
        <div style={s.card}>

          <div style={s.icon}>
            {loggedIn?'🏢':'🔐'}
          </div>

          <div style={s.bigTitle}>
            {loggedIn?'选择送达位置':'已审核人员登录'}
          </div>

          {!loggedIn ? (
            <>
              <div style={s.desc}>
                使用审核通过时登记的手机号和6位通行密码登录
              </div>

              <div style={s.label}>
                手机号码
              </div>

              <input
                style={s.input}
                value={phone}
                inputMode="numeric"
                autoComplete="tel"
                placeholder="请输入本人手机号码"
                onChange={e=>
                  setPhone(
                    e.target.value.replace(/\D/g,'').slice(0,11)
                  )
                }
              />

              <div style={s.label}>
                6位通行密码
              </div>

              <input
                style={s.input}
                type="password"
                value={passcode}
                inputMode="numeric"
                autoComplete="current-password"
                placeholder="请输入6位数字通行密码"
                onChange={e=>
                  setPasscode(
                    e.target.value.replace(/\D/g,'').slice(0,6)
                  )
                }
              />

              {msg&&(
                <div style={s.error}>
                  {msg}
                </div>
              )}

              <button
                type="button"
                style={{
                  ...s.primaryBtn,
                  opacity:busy?.65:1
                }}
                disabled={busy}
                onClick={login}
              >
                {busy?'正在验证...':'登录'}
              </button>

              <div style={s.registerEntry}>
                <div style={s.registerHint}>
                  还没有注册？
                </div>

                <button
                  type="button"
                  style={s.registerBtn}
                  onClick={onRegister}
                >
                  首次注册
                </button>
              </div>
            </>
          ):(
            <>
              <div style={s.desc}>
                身份验证已通过，请选择本次送达位置
              </div>

              <div style={s.loginOk}>
                ✓ 已通过人员身份验证
                {account?.real_name
                  ? ` · ${account.real_name}`
                  : ''
                }
              </div>

              <div style={s.label}>
                选择送达楼幢
              </div>

              <div style={s.buildingGrid}>
                {Object.keys(DELIVERY_BUILDINGS).map(name=>{
                  const no=name.replace('幢','');
                  const active=String(buildingNo)===String(no);

                  return (
                    <button
                      type="button"
                      key={name}
                      style={{
                        ...s.buildingBtn,
                        ...(active?s.buildingBtnOn:{})
                      }}
                      onClick={()=>{
                        setBuildingNo(no);
                        setUnitNo('');
                        setUnitName('');
                        setRoomNo('');
                      }}
                    >
                      🏢 {name}
                    </button>
                  );
                })}
              </div>

              {buildingNo&&(()=>{
                const bName=`${buildingNo}幢`;
                const bInfo=DELIVERY_BUILDINGS[bName];

                return (
                  <>
                    <div style={s.label}>
                      选择单元
                    </div>

                    <div style={s.unitGroupRow}>
                      {bInfo.unitGroups.map(group=>(
                        <button
                          type="button"
                          key={group.name}
                          style={{
                            ...s.unitGroupBtn,
                            ...(String(unitNo)===String(group.unitNo)
                              ? s.unitGroupBtnOn
                              : {})
                          }}
                          onClick={()=>{
                            setUnitNo(group.unitNo);
                            setUnitName(group.name);
                            setRoomNo('');
                          }}
                        >
                          {group.name}
                        </button>
                      ))}
                    </div>
                  </>
                );
              })()}

              {buildingNo&&unitNo&&(()=>{
                const bName=`${buildingNo}幢`;
                const bInfo=DELIVERY_BUILDINGS[bName];
                const group=bInfo.unitGroups.find(
                  x=>String(x.unitNo)===String(unitNo)
                );

                if(!group) return null;

                return (
                  <>
                    <div style={s.label}>
                      选择具体房号
                    </div>

                    <div style={s.roomPicker}>
                      {Array.from(
                        {length:bInfo.floors},
                        (_,i)=>bInfo.floors+1-i
                      ).map(floor=>(
                        <div key={floor} style={s.floorRow2}>
                          <div style={s.floorLabel2}>
                            {floor}F
                          </div>

                          <div style={s.roomRow2}>
                            {group.rooms.map(room=>{
                              const fullRoom=`${floor}${room}`;
                              const active=roomNo===fullRoom;

                              return (
                                <button
                                  type="button"
                                  key={room}
                                  style={{
                                    ...s.roomBtn2,
                                    ...(active?s.roomBtnOn2:{})
                                  }}
                                  onClick={()=>setRoomNo(fullRoom)}
                                >
                                  {fullRoom}
                                </button>
                              );
                            })}
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                );
              })()}

              {roomNo&&(
                <div style={s.selectedRoom}>
                  已选择：
                  <b>
                    {buildingNo}幢{unitName}{roomNo}室
                  </b>
                </div>
              )}

              <div style={s.accessTip}>
                本次权限默认15分钟，仅开放公共入口和所选目标单元。
              </div>

              {msg&&(
                <div style={s.error}>
                  {msg}
                </div>
              )}

              <button
                type="button"
                style={{
                  ...s.primaryBtn,
                  opacity:busy?.65:1
                }}
                disabled={busy}
                onClick={requestAccess}
              >
                {busy
                  ? '正在申请...'
                  : '申请15分钟临时通行'
                }
              </button>
            </>
          )}

        </div>
      </div>
    </div>
  );
}

function RegisterForm({token,onBack}){

  const [form,setForm]=useState({
    real_name:'',
    phone:'',
    id_card_no:'',
    person_category:'外卖',
    delivery_platform:'',
    passcode:'',
    passcode2:''
  });

  const [faceFile,setFaceFile]=useState(null);
  const [facePreview,setFacePreview]=useState('');
  const [cameraOpen,setCameraOpen]=useState(false);

  const [agree,setAgree]=useState(false);
  const [busy,setBusy]=useState(false);
  const [msg,setMsg]=useState('');
  const [success,setSuccess]=useState(null);

  const [smsCode,setSmsCode]=useState('');
  const [smsVerified,setSmsVerified]=useState(false);
  const [smsBusy,setSmsBusy]=useState(false);
  const [smsInfo,setSmsInfo]=useState('');
  const [countdown,setCountdown]=useState(0);

  useEffect(()=>{
    if(countdown<=0)return;
    const timer=setInterval(()=>{
      setCountdown(v=>v>0?v-1:0);
    },1000);
    return()=>clearInterval(timer);
  },[countdown]);

  const set=(k,v)=>setForm(f=>({...f,[k]:v}));

  const choose=(e,setFile,setPreview)=>{
    const f=e.target.files?.[0];
    if(!f)return;

    setFile(f);
    setPreview(URL.createObjectURL(f));
  };

  const sendSms=async()=>{
    setMsg('');
    setSmsInfo('');

    const phone=form.phone.replace(/\D/g,'');

    if(!/^1\d{10}$/.test(phone))
      return setMsg('请输入正确的11位手机号码');

    setSmsBusy(true);

    try{
      const r=await fetch(
        `/api/delivery/public/${encodeURIComponent(token)}/sms/send`,
        {
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify({phone})
        }
      );

      const d=await r.json();

      if(!r.ok)
        throw new Error(d.message||'验证码发送失败');

      setCountdown(Number(d.resend_after||60));
      setSmsInfo('验证码已发送，请查收短信');

    }catch(e){
      setMsg(e.message);
    }finally{
      setSmsBusy(false);
    }
  };

  const verifySms=async()=>{
    setMsg('');
    setSmsInfo('');

    const phone=form.phone.replace(/\D/g,'');
    const code=smsCode.replace(/\D/g,'');

    if(!/^1\d{10}$/.test(phone))
      return setMsg('请输入正确的11位手机号码');

    if(!/^\d{6}$/.test(code))
      return setMsg('请输入6位短信验证码');

    setSmsBusy(true);

    try{
      const r=await fetch(
        `/api/delivery/public/${encodeURIComponent(token)}/sms/verify`,
        {
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify({phone,code})
        }
      );

      const d=await r.json();

      if(!r.ok)
        throw new Error(d.message||'验证码验证失败');

      setSmsVerified(true);
      setSmsInfo('手机号码已验证');

    }catch(e){
      setMsg(e.message);
    }finally{
      setSmsBusy(false);
    }
  };

  const submit=async()=>{

    setMsg('');

    const name=form.real_name.trim();
    const phone=form.phone.replace(/\D/g,'');
    const id=form.id_card_no.trim().toUpperCase();

    if(name.length<2)
      return setMsg('请填写本人真实姓名');

    if(!/^1\d{10}$/.test(phone))
      return setMsg('请输入正确的11位手机号码');

    if(!smsVerified)
      return setMsg('请先完成手机短信验证');

    if(!/^\d{17}[\dX]$/.test(id))
      return setMsg('请输入正确的18位身份证号码');

    if(!/^\d{6}$/.test(form.passcode))
      return setMsg('请设置6位数字通行密码');

    if(form.passcode!==form.passcode2)
      return setMsg('两次输入的通行密码不一致');


    if(!faceFile)
      return setMsg('请拍摄本人正脸照片');

    if(!agree)
      return setMsg('请阅读并同意人员通行登记规则');

    const fd=new FormData();

    fd.append('real_name',name);
    fd.append('phone',phone);
    fd.append('id_card_no',id);
    fd.append('person_category',form.person_category);
    fd.append('delivery_platform',form.delivery_platform.trim());
    fd.append('passcode',form.passcode);

    fd.append('face_photo',faceFile);

    setBusy(true);

    try{

      const r=await fetch(
        `/api/delivery/public/${encodeURIComponent(token)}/register`,
        {
          method:'POST',
          body:fd
        }
      );

      const d=await r.json();

      if(!r.ok)
        throw new Error(d.message||'注册提交失败');

      setSuccess(d);

    }catch(e){
      setMsg(e.message);
    }finally{
      setBusy(false);
    }
  };

  if(success){
    return (
      <div style={s.page}>
        <Header
          title={
            success?.auto_approved
              ? '实名认证成功'
              : '注册提交成功'
          }
        />

        <div style={s.body}>
          <div style={s.card}>

            <div style={s.successIcon}>✓</div>

            <div style={s.bigTitle}>
              {success?.auto_approved
              ? '账号已自动启用'
              : '注册资料已提交'}
            </div>

            <div style={s.successText}>
              {success?.auto_approved
              ? '无需等待人工审核，现在即可申请临时通行。'
              : '请等待物业秩序员或消控人员审核。'}
            </div>

            <div style={s.resultBox}>
              <div>
                人员类别：
                <b>{form.person_category}</b>
              </div>

              <div>
                手机号码：
                <b>
                  {form.phone.slice(0,3)}
                  ****
                  {form.phone.slice(-4)}
                </b>
              </div>

              <div>
                当前状态：
                <b style={{color:'#fa8c16'}}>
                  待物业审核
                </b>
              </div>
            </div>

            <div style={s.desc}>
              审核通过以后，下次扫码可使用手机号和6位通行密码申请临时通行。
            </div>

            <Warning/>

          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={s.page}>

      <Header
        title="首次注册"
        back={onBack}
      />

      <div style={s.body}>

        <div style={s.card}>

          <div style={s.sectionTitle}>
            人员类别
          </div>

          <div style={s.categoryGrid}>
            {[
              ['外卖','🍱'],
              ['快递','📦'],
              ['装修工','🛠️']
            ].map(([name,icon])=>(

              <button
                type="button"
                key={name}
                onClick={()=>set('person_category',name)}
                style={{
                  ...s.categoryBtn,
                  ...(form.person_category===name
                    ? s.categoryOn
                    : {})
                }}
              >
                <div style={{fontSize:25}}>
                  {icon}
                </div>
                {name}
              </button>

            ))}
          </div>

          {form.person_category==='装修工'&&(
            <div style={s.decoratorWarning}>
              ⚠ 装修人员每日08:00前禁止进入小区
            </div>
          )}

          <Field
            title="本人姓名"
            value={form.real_name}
            placeholder="请输入身份证上的姓名"
            onChange={v=>set('real_name',v)}
          />

          <div style={s.label}>
            手机号码
          </div>

          <div style={s.smsRow}>
            <input
              style={{...s.input,flex:1,minWidth:0}}
              value={form.phone}
              inputMode="numeric"
              disabled={smsVerified}
              placeholder="请输入本人手机号码"
              onChange={e=>{
                const v=e.target.value.replace(/\D/g,'').slice(0,11);
                set('phone',v);
                setSmsCode('');
                setSmsVerified(false);
                setSmsInfo('');
              }}
            />

            <button
              type="button"
              style={s.smsBtn}
              disabled={
                smsBusy ||
                smsVerified ||
                countdown>0 ||
                form.phone.length!==11
              }
              onClick={sendSms}
            >
              {smsVerified
                ? '已验证'
                : smsBusy
                  ? '发送中'
                  : countdown>0
                    ? `${countdown}秒`
                    : '获取验证码'
              }
            </button>
          </div>

          <div style={s.label}>
            短信验证码
          </div>

          <div style={s.smsRow}>
            <input
              style={{...s.input,flex:1,minWidth:0}}
              value={smsCode}
              inputMode="numeric"
              disabled={smsVerified}
              placeholder="请输入6位验证码"
              onChange={e=>
                setSmsCode(
                  e.target.value.replace(/\D/g,'').slice(0,6)
                )
              }
            />

            <button
              type="button"
              style={s.smsBtn}
              disabled={
                smsBusy ||
                smsVerified ||
                smsCode.length!==6
              }
              onClick={verifySms}
            >
              {smsVerified?'✓ 已验证':'验证'}
            </button>
          </div>

          {smsVerified&&(
            <div style={s.smsOk}>
              ✓ 手机号码已验证
            </div>
          )}

          {smsInfo&&!smsVerified&&(
            <div style={s.smsInfo}>
              {smsInfo}
            </div>
          )}

          <Field
            title="身份证号码"
            value={form.id_card_no}
            placeholder="请输入本人18位身份证号码"
            onChange={v=>
              set(
                'id_card_no',
                v.toUpperCase().slice(0,18)
              )
            }
          />

          <Field
            title="所属平台 / 单位（可选）"
            value={form.delivery_platform}
            placeholder={
              form.person_category==='装修工'
                ? '例如：XX装修公司'
                : '例如：美团、饿了么、顺丰、京东'
            }
            onChange={v=>set('delivery_platform',v)}
          />


          <div style={s.label}>
            本人正脸照片
          </div>

          <div style={{
            fontSize:13,
            color:'#666',
            lineHeight:1.7,
            margin:'-4px 0 9px'
          }}>
            此照片用于门禁人脸识别，请本人现场拍摄。正面免冠、无遮挡、光线均匀，请勿逆光。
          </div>

          <div onClick={()=>setCameraOpen(true)} style={{
            ...s.photoBox,
            minHeight:285,
            border:'2px dashed #79c8df',
            background:'#f7fcff',
            display:'flex',
            alignItems:'center',
            justifyContent:'center',
            flexDirection:'column',
            overflow:'hidden',
            position:'relative'
          }}>

            {facePreview
              ? <>
                  <img
                    src={facePreview}
                    alt="本人正脸照片"
                    style={{
                      ...s.photo,
                      width:'100%',
                      maxHeight:360,
                      objectFit:'contain'
                    }}
                  />
                  <div style={{
                    width:'100%',
                    boxSizing:'border-box',
                    padding:'10px',
                    textAlign:'center',
                    fontSize:14,
                    color:'#078dbd',
                    fontWeight:700,
                    background:'#eefaff'
                  }}>
                    ✓ 正脸照片已拍摄 · 点击这里可重新拍摄
                  </div>
                </>
              : <div style={{
                  width:'100%',
                  textAlign:'center',
                  padding:'18px 12px',
                  boxSizing:'border-box'
                }}>

                  <div style={{
                    fontSize:16,
                    fontWeight:800,
                    color:'#333',
                    marginBottom:6
                  }}>
                    请将人脸置于取景区域中央
                  </div>

                  <div style={{
                    fontSize:13,
                    color:'#777',
                    marginBottom:14
                  }}>
                    正面免冠 · 光线均匀 · 请勿逆光
                  </div>

                  <div style={{
                    width:150,
                    height:190,
                    margin:'0 auto',
                    border:'3px solid #31a9ce',
                    borderRadius:'48% 48% 45% 45%',
                    position:'relative',
                    boxSizing:'border-box',
                    background:'linear-gradient(180deg,#eefaff,#ffffff)'
                  }}>

                    <div style={{
                      position:'absolute',
                      left:'50%',
                      top:35,
                      transform:'translateX(-50%)',
                      width:72,
                      height:86,
                      border:'2px solid #8fcfe2',
                      borderRadius:'50%'
                    }}/>

                    <div style={{
                      position:'absolute',
                      left:'50%',
                      bottom:23,
                      transform:'translateX(-50%)',
                      width:105,
                      height:55,
                      border:'2px solid #8fcfe2',
                      borderRadius:'60px 60px 15px 15px',
                      borderBottom:0
                    }}/>

                  </div>

                  <div style={{
                    marginTop:13,
                    fontSize:14,
                    color:'#078dbd',
                    fontWeight:700
                  }}>
                    人脸大小约占画面 40%～60%
                  </div>

                  <div style={{
                    marginTop:14,
                    display:'inline-block',
                    background:'#0798c4',
                    color:'#fff',
                    padding:'10px 22px',
                    borderRadius:22,
                    fontSize:15,
                    fontWeight:700
                  }}>
                    📷 点击拍摄本人正脸
                  </div>

                  <div style={{
                    marginTop:12,
                    fontSize:12,
                    lineHeight:1.6,
                    color:'#999'
                  }}>
                    请勿戴口罩、墨镜或帽子<br/>
                    请勿使用他人照片或翻拍照片
                  </div>

                </div>
            }

              <FaceCamera
                open={cameraOpen}
                onClose={()=>setCameraOpen(false)}
                onCapture={(file,url)=>{
                  setFaceFile(file);
                  setFacePreview(url);
                  setCameraOpen(false);
                }}
              />

          </div>

          <Field
            title="设置6位通行密码"
            value={form.passcode}
            type="password"
            inputMode="numeric"
            placeholder="请输入6位数字"
            onChange={v=>
              set(
                'passcode',
                v.replace(/\D/g,'').slice(0,6)
              )
            }
          />

          <Field
            title="再次输入通行密码"
            value={form.passcode2}
            type="password"
            inputMode="numeric"
            placeholder="再次输入6位数字"
            onChange={v=>
              set(
                'passcode2',
                v.replace(/\D/g,'').slice(0,6)
              )
            }
          />

          <Warning/>

          <label style={s.agree}>

            <input
              type="checkbox"
              checked={agree}
              onChange={e=>
                setAgree(e.target.checked)
              }
            />

            <span>
              我确认以上资料均由本人填写并真实有效，
              同意物业用于身份审核、临时门禁及通行记录管理。
            </span>

          </label>

          {msg&&(
            <div style={s.error}>
              {msg}
            </div>
          )}

          <button
            type="button"
            disabled={busy}
            style={{
              ...s.primaryBtn,
              opacity:busy?.65:1
            }}
            onClick={submit}
          >
            {busy
              ? '正在提交...'
              : '提交物业审核'
            }
          </button>

          <div style={s.safe}>
            🔒 密码经过加密保存；身份证及人脸属于敏感资料，请勿代他人注册
          </div>

        </div>
      </div>
    </div>
  );
}

function Field({
  title,
  value,
  onChange,
  placeholder,
  type='text',
  inputMode
}){
  return (
    <>
      <div style={s.label}>
        {title}
      </div>

      <input
        style={s.input}
        type={type}
        inputMode={inputMode}
        value={value}
        placeholder={placeholder}
        onChange={e=>onChange(e.target.value)}
      />
    </>
  );
}

function Warning(){
  return (
    <div style={s.warning}>
      <b>⚠ 通行登记须知</b>

      <div>
        请使用本人真实身份注册。
      </div>

      <div>
        冒用身份、虚假资料、账号转借等违规行为，
        经物业核实后将列入黑名单并禁止通行。
      </div>

      <div>
        <b>
          装修人员每日08:00前禁止进入小区。
        </b>
      </div>
    </div>
  );
}

function Header({title,back}){
  return (
    <div style={s.header}>

      <div style={s.headSide}>
        {back&&(
          <button
            style={s.back}
            onClick={back}
          >
            ← 返回
          </button>
        )}
      </div>

      <div style={s.headerTitle}>
        {title}
      </div>

      <div style={s.headSide}/>

    </div>
  );
}

function Center({children}){
  return (
    <div style={s.center}>
      {children}
    </div>
  );
}

const s={
  page:{
    minHeight:'100vh',
    background:'#eef6ff'
  },

  header:{
    minHeight:64,
    background:'linear-gradient(90deg,#078dbd,#08a8c9)',
    color:'#fff',
    display:'flex',
    alignItems:'center',
    padding:'0 12px',
    boxSizing:'border-box',
    position:'sticky',
    top:0,
    zIndex:20
  },

  headSide:{
    width:75,
    flexShrink:0
  },

  back:{
    border:0,
    background:'transparent',
    color:'#fff',
    padding:5,
    fontSize:15
  },

  headerTitle:{
    flex:1,
    textAlign:'center',
    fontSize:20,
    lineHeight:1.2,
    fontWeight:800,
    whiteSpace:'nowrap'
  },

  body:{
    maxWidth:620,
    margin:'0 auto',
    padding:16
  },

  card:{
    background:'#fff',
    borderRadius:18,
    padding:20,
    boxShadow:'0 4px 18px rgba(0,0,0,.07)'
  },

  brand:{
    textAlign:'center',
    color:'#078dbd',
    fontSize:18,
    fontWeight:700
  },

  icon:{
    textAlign:'center',
    fontSize:55,
    margin:'22px 0 8px'
  },

  bigTitle:{
    textAlign:'center',
    fontSize:25,
    fontWeight:800,
    color:'#222',
    margin:'10px 0'
  },

  desc:{
    textAlign:'center',
    color:'#777',
    lineHeight:1.7,
    margin:'8px 0 22px'
  },

  primaryBtn:{
    width:'100%',
    border:0,
    borderRadius:13,
    padding:'15px 12px',
    background:'#0798c4',
    color:'#fff',
    fontSize:17,
    fontWeight:700,
    marginTop:14
  },

  secondaryBtn:{
    width:'100%',
    border:'1px solid #0798c4',
    borderRadius:13,
    padding:'15px 12px',
    background:'#fff',
    color:'#0798c4',
    fontSize:17,
    fontWeight:700,
    marginTop:12
  },

  grayBtn:{
    width:'100%',
    border:0,
    borderRadius:13,
    padding:14,
    background:'#eee',
    fontSize:16,
    marginTop:16
  },

  loginOk:{
    padding:'11px 12px',
    borderRadius:10,
    background:'#f0fff4',
    color:'#27864b',
    fontSize:14,
    fontWeight:700,
    marginBottom:8
  },

  accessTip:{
    marginTop:16,
    padding:'12px 13px',
    borderRadius:10,
    background:'#f2f9ff',
    color:'#28799b',
    lineHeight:1.6,
    fontSize:14
  },

  resultBox:{
    padding:'16px',
    borderRadius:12,
    background:'#f7fbfd',
    lineHeight:2,
    fontSize:15
  },

  buildingGrid:{
    display:'grid',
    gridTemplateColumns:'repeat(2,1fr)',
    gap:10
  },

  buildingBtn:{
    border:'1px solid #cde5ef',
    background:'#fff',
    borderRadius:12,
    padding:'15px 8px',
    color:'#087fa8',
    fontSize:16,
    fontWeight:700
  },

  buildingBtnOn:{
    background:'#0798c4',
    color:'#fff',
    borderColor:'#0798c4'
  },

  unitGroupRow:{
    display:'flex',
    gap:10
  },

  unitGroupBtn:{
    flex:1,
    border:'1px solid #cde5ef',
    background:'#fff',
    borderRadius:10,
    padding:'12px 8px',
    color:'#087fa8',
    fontSize:16,
    fontWeight:700
  },

  unitGroupBtnOn:{
    background:'#0798c4',
    color:'#fff',
    borderColor:'#0798c4'
  },

  roomPicker:{
    marginTop:6,
    maxHeight:430,
    overflowY:'auto',
    paddingRight:2
  },

  floorRow2:{
    display:'flex',
    alignItems:'center',
    gap:8,
    marginBottom:8
  },

  floorLabel2:{
    width:34,
    flexShrink:0,
    fontSize:12,
    color:'#0077b6',
    fontWeight:700
  },

  roomRow2:{
    flex:1,
    display:'grid',
    gridTemplateColumns:'repeat(2,1fr)',
    gap:8
  },

  roomBtn2:{
    border:'1px solid #cde5ef',
    background:'#eaf8ff',
    borderRadius:9,
    padding:'10px 6px',
    fontSize:15,
    color:'#087fa8',
    fontWeight:700
  },

  roomBtnOn2:{
    background:'#0798c4',
    color:'#fff',
    borderColor:'#0798c4'
  },

  selectedRoom:{
    marginTop:16,
    padding:'13px',
    borderRadius:10,
    background:'#f0fff4',
    color:'#247744',
    textAlign:'center',
    fontSize:15
  },

  registerEntry:{
    marginTop:18,
    paddingTop:16,
    borderTop:'1px solid #edf0f2',
    textAlign:'center'
  },

  registerHint:{
    color:'#888',
    fontSize:14,
    marginBottom:8
  },

  registerBtn:{
    border:'1px solid #0798c4',
    background:'#fff',
    color:'#0798c4',
    borderRadius:11,
    padding:'11px 28px',
    fontSize:15,
    fontWeight:700
  },

  sectionTitle:{
    fontSize:17,
    fontWeight:800,
    marginBottom:12
  },

  categoryGrid:{
    display:'grid',
    gridTemplateColumns:'repeat(3,1fr)',
    gap:8
  },

  categoryBtn:{
    border:'1px solid #cde5ef',
    background:'#fff',
    borderRadius:12,
    padding:'12px 4px',
    color:'#087fa8',
    fontSize:15
  },

  categoryOn:{
    background:'#0798c4',
    color:'#fff'
  },

  decoratorWarning:{
    marginTop:10,
    padding:11,
    borderRadius:10,
    background:'#fff1f0',
    color:'#cf1322',
    fontWeight:700,
    textAlign:'center'
  },

  label:{
    fontSize:15,
    color:'#444',
    fontWeight:600,
    margin:'18px 0 8px'
  },

  input:{
    width:'100%',
    boxSizing:'border-box',
    border:'1px solid #d6dde3',
    borderRadius:11,
    padding:'13px 12px',
    fontSize:16,
    outline:'none'
  },

  photoBox:{
    minHeight:150,
    border:'1px dashed #9caab3',
    borderRadius:12,
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    overflow:'hidden',
    background:'#fafafa',
    color:'#666'
  },

  photo:{
    width:'100%',
    maxHeight:280,
    objectFit:'contain'
  },

  smsRow:{
    display:'flex',
    gap:8,
    alignItems:'stretch'
  },

  smsBtn:{
    width:118,
    flexShrink:0,
    border:0,
    borderRadius:11,
    background:'#0798c4',
    color:'#fff',
    fontSize:14,
    fontWeight:700,
    padding:'0 8px'
  },

  smsOk:{
    marginTop:8,
    padding:10,
    borderRadius:9,
    background:'#f6ffed',
    color:'#389e0d',
    fontWeight:700
  },

  smsInfo:{
    marginTop:8,
    padding:10,
    borderRadius:9,
    background:'#e6f7ff',
    color:'#096dd9'
  },

  warning:{
    marginTop:20,
    padding:'13px 14px',
    background:'#fff7e6',
    color:'#8c4a00',
    border:'1px solid #ffd591',
    borderRadius:12,
    fontSize:13,
    lineHeight:1.8
  },

  agree:{
    display:'flex',
    alignItems:'flex-start',
    gap:8,
    marginTop:18,
    fontSize:13,
    color:'#555',
    lineHeight:1.7
  },

  error:{
    marginTop:15,
    background:'#fff1f0',
    color:'#cf1322',
    padding:11,
    borderRadius:9
  },

  safe:{
    textAlign:'center',
    color:'#999',
    fontSize:12,
    lineHeight:1.6,
    marginTop:14
  },

  successIcon:{
    width:70,
    height:70,
    borderRadius:'50%',
    margin:'20px auto',
    background:'#52c41a',
    color:'#fff',
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    fontSize:42,
    fontWeight:800
  },

  successText:{
    textAlign:'center',
    color:'#555',
    fontSize:16,
    marginBottom:18
  },

  resultBox:{
    padding:15,
    borderRadius:12,
    background:'#f5f8fa',
    lineHeight:2
  },

  center:{
    minHeight:'100vh',
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    color:'#777'
  }
};
